import React from 'react';
import {Col, Row} from "reactstrap";
import Skeleton from "react-loading-skeleton";

const SkeletonMangeSubscriptionTable = ({props})=>{

    return(
        <div className={'animated fadeIn animation-duration-7'}>
            <Row>
                <Col>
                    <h2>
                        BreachRisk&trade;
                    </h2>
                </Col>
            </Row>

            <Row>
                <Col>
                    <h2>
                        View and monitor
                    </h2>
                </Col>
            </Row>

            <Row className={"text-center align-self-center m-2 p-2"}>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
            </Row>

            <Row className={"text-center align-self-center m-2 p-2"}>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
            </Row>

            <Row className={"text-center align-self-center m-2 p-2"}>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
            </Row>

            <Row className={"text-center align-self-center m-2 p-2"}>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
            </Row>

            <Row className={"text-center align-self-center m-2 p-2"}>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
            </Row>

            <Row className={"text-center align-self-center m-2 p-2"}>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
                <Col className={"border-bottom border-right border-dark"}>
                    <Skeleton style={{width: "100%"}}> </Skeleton>
                </Col>
            </Row>
        </div>
    )
}

export default SkeletonMangeSubscriptionTable;